import {
    MESSAGECATALOG_LOAD,
    MESSAGECATALOG_RELOAD,
    MESSAGECATALOG_RECEIVE,
    MESSAGECATALOG_SET_LANGUAGE
} from '../constants';

import messageCatalog from '~/shared/src/utilities/messageCatalog';

import {
    LoadAction,
    ReceiveAction,
    ReloadAction,
    SetLanguageAction
} from '~/frontend/src/actions/messagecatalog';


export type MessageCatalogState = Partial<{
    isLoading : boolean;
    isReady : boolean;
    timestamp : number;
}>;


const relevantActions = [
    MESSAGECATALOG_LOAD,
    MESSAGECATALOG_RELOAD,
    MESSAGECATALOG_RECEIVE,
    MESSAGECATALOG_SET_LANGUAGE
];


export default function messagecatalogReducer( state : MessageCatalogState = {}, action : LoadAction | ReloadAction | ReceiveAction | SetLanguageAction ) : MessageCatalogState {
    let retVal = state;

    if ( relevantActions.includes( action.type ) ) {
        retVal = {
            ...state
        };

        switch ( action.type ) {
            case MESSAGECATALOG_LOAD:
                retVal.isLoading = true;
                break;

            case MESSAGECATALOG_RELOAD:
                retVal.isReady = false;
                retVal.isLoading = true;
                break;

            case MESSAGECATALOG_RECEIVE:
                retVal.isReady = true;
                retVal.isLoading = false;
                retVal.timestamp = messageCatalog.getTimestamp();
                break;

            case MESSAGECATALOG_SET_LANGUAGE:
                break;
        }
    }

    return retVal;
}
